import { render, staticRenderFns } from "./IconDispute.vue?vue&type=template&id=b5a0d288&"
import script from "./IconDispute.vue?vue&type=script&lang=js&"
export * from "./IconDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports